

export default function Footer() {
  return (
    <footer className="bg-white/5 backdrop-blur-md border-t border-white/10 py-3 sm:py-4">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="flex items-center justify-center">
          <p className="text-xs sm:text-sm text-white/60 font-medium text-center">
            © 2024 Crypto Ocean Pty Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
} 